import { Box, Stack, Typography, styled } from '@mui/material';

export const SectionStackStyled = styled(Stack)(({ theme }) => ({
  margin: theme.spacing(6, 0),
  // [theme.breakpoints.up('md')]: {
  //   width: '70%',
  // },
}));

export const SectionBoxStyled = styled(Box)(({ theme }) => ({
  margin: theme.spacing(6, 9),
}));

export const ProfilePictureStyled = styled(Box)(({ theme }) => ({
  margin: theme.spacing(8, 5),
  padding: theme.spacing(8, 0),
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    margin: 0,
  },
}));

export const StyledTypography = styled(Typography)({
  fontWeight: 600,
});
